if (URLSearchParams && location.search) {
    const params = new URLSearchParams(location.search);
    const country = params.get('location');

    if (country !== 'null') {
        localStorage.setItem('country', country);
    }
}
